import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ECaseSnackBarService, ECaseUtils, ExplorerService} from 'synto-common';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DocumentItem} from '../document-list.models';

export interface DocumentArchiveDialogData {
  row: DocumentItem;
}

@Component({
  selector: 'app-document-archive-dialog',
  templateUrl: './document-archive-dialog.component.html'
})
export class DocumentArchiveDialogComponent implements OnDestroy {

  submitting = false;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DocumentArchiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentArchiveDialogData,
    private translate: TranslateService,
    private explorerService: ExplorerService,
    private eCaseSnackBarService: ECaseSnackBarService
  ) {
  }

  onConfirm(): void {
    if (!this.data?.row || this.submitting) {
      return;
    }
    const edmRepositoryDocumentId = this.data.row?.edmRepositoryDocumentId;
    if (!edmRepositoryDocumentId) {
      this.eCaseSnackBarService.show(
        'failure',
        ECaseUtils.getTranslatedValueFromKey(this.translate, 'ecase.explorer.documentList.archive.documentIdMissing')
      );
      return;
    }
    this.submitting = true;
    this.explorerService.archiveDocument(edmRepositoryDocumentId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.eCaseSnackBarService.show(
            'success',
            ECaseUtils.getTranslatedValueFromKey(this.translate, 'ecase.explorer.documentList.archive.success')
          );
          this.dialogRef.close(true);
        },
        error: (error: any) => {
          this.submitting = false;
          const errorMessage = error?.errorMessage ||
            error?.error?.errorMessage ||
            error?.error?.message ||
            error?.message ||
            'ecase.explorer.documentList.archive.error';
          this.eCaseSnackBarService.show(
            'failure',
            ECaseUtils.getTranslatedValueFromKey(this.translate, errorMessage)
          );
        }
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
